// extracted by mini-css-extract-plugin
export var contact_button = "style-module--contact_button--adb13";
export var contactwrap_pc = "style-module--contactwrap_pc--8fcc1";
export var contactwrap_sp = "style-module--contactwrap_sp--b4561";
export var container = "style-module--container--76cad";
export var logo = "style-module--logo--c43db";
export var logo_otherPage = "style-module--logo_otherPage--0f1f0";
export var logo_topPage = "style-module--logo_topPage--1023c";
export var menu = "style-module--menu--88109";
export var nav = "style-module--nav--d7e0e";
export var nav_bottom = "style-module--nav_bottom--83591";
export var nav_container = "style-module--nav_container--0f219";
export var nav_item = "style-module--nav_item--1e669";
export var nav_list = "style-module--nav_list--79a33";
export var nav_open = "style-module--nav_open--46d58";
export var sns = "style-module--sns--7f57b";
export var sns_item = "style-module--sns_item--eb6da";
export var sns_list = "style-module--sns_list--258d8";